import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { connect, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { NavigationRoutes } from '../../constant/Routes';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import AddMake from './components/AddMake';
import { makeLisitingRequest, deleteMake, addBulkMakeModel, syncVehiclesData } from './redux/makeDispatcher';
import { getCategoryLisiting } from '../category/redux/categoryDispatcher';


function MakeListing({ makeListing }) {
  const { make_name, parent_name } = useParams();
  let makeName = make_name
    ? decodeURIComponent(make_name).trim()
    : null;

  let parentName = parent_name
    ? decodeURIComponent(parent_name).trim()
    : "__ROOT__";

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [categories, setCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [syncLoading, setSyncLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const refreshMakeList = () => {

    return { page, pageSize, searchTerm };
  };

  const makeListingHeading = [

    {
      field: "id", headerName: "NO", width: 40,
      renderCell: (params) =>
        params.api.getRowIndexRelativeToVisibleRows(params.id) + 1 + (page * pageSize),
    },

    {

      field: "name", headerName: (makeListing.makeDetail === null ? "MAKE" : makeListing.makeDetail?.type === "MAKE" ? "MODEL" : "VARIANT"), width: 150
    },


    {
      field: "body_type",
      headerName: "BODY TYPE",
      flex: 1,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",   // ✅ vertical center
            height: "100%",
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "1.4"
          }}
        >
          {params.value}
        </div>
      )
    },
    {
      field: "action",
      headerName: "Action",
      width: parentName === "__ROOT__" ? 300 : 170,
      sortable: false,

      renderCell: (params, row) => (
        <div style={{
          display: "flex", flexDirection: "row", gap: "4px", alignItems: "center",
          height: "100%"
        }}>


          {

            makeListing.makeDetail?.type !== 'MODEL' ? <button
              onClick={async () => {

                await setPage(0);
                await setSearchTerm("");
                console.log("veiw is called", params, row);
                navigate(
                  NavigationRoutes.ADMIN_DASHBOARD +
                  NavigationRoutes.VEHICLE_MODEL
                    .replace(":make_name", params.row.make_name)
                    .replace(":parent_name", params.row.name)
                );
              }}
              style={{
                backgroundColor: "#4CAF50",
                color: "white",
                border: "none",
                cursor: "pointer",
                borderRadius: "4px",
                fontSize: "10px",
                width: "100%",
                height: "24px",  // Increased height
                padding: "2px 5px", // Added padding
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {makeListing.makeDetail === null ? "Model" : "Variant"}
            </button> : <div></div>
          }

          <AddMake
            parent_name={parentName}
            make_name={makeName}

            buttonLabel={makeListing.makeDetail === null ? "EDIT MAKE" : makeListing.makeDetail?.type?.toUpperCase() === "MAKE" ? "EDIT MODEL" : "EDIT VARIANT"}
            editMode={true}
            makeData={params.row}
            categories={categories}
            data={makeListing.makeDetail}
            onSave={refreshMakeList}

          />


          <button
            onClick={() => handleDelete(params.row)}
            style={{
              backgroundColor: "#F44336",
              color: "white",
              border: "none",
              cursor: "pointer",
              borderRadius: "4px",
              fontSize: "10px",
              width: "100%",
              height: "24px",  // Increased height
              padding: "2px 5px", // Added padding
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Delete
          </button>
        </div>

      ),
    },
  ];


  const handleDelete = (row) => {
    console.log("Deleting Make ID:", row);
    Swal.fire({
      title: ``,
      html:
        "" +
        "Are you sure?" +
        "<br>" +
        `You want to Delete ${parentName === "__ROOT__" ? "make" : "model"} "${row.name}"`,
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: `Yes, Delete`,
      showCloseButton: true,
      cancelButtonColor: "gray",
      confirmButtonColor: "#4f83df",
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch(deleteMake(row.id, parentName, makeName, pageSize, page + 1, searchTerm));
      }
    });

  };



  const fetchedRef = React.useRef(false);

  React.useEffect(() => {
    console.log("checking useeffect", parentName);


    if (!fetchedRef.current) {
      fetchedRef.current = true; // mark as fetched

      const fetchCategories = async () => {
        try {
          const result = await dispatch(getCategoryLisiting());
          var cat = result.filter(item => item.is_vehicle === 1)
          setCategories(cat);

          console.log("Fetched categories:", cat);
        } catch (error) {
          console.error("Error fetching categories:", error);
        }
      };

      fetchCategories();
    }

    dispatch(makeLisitingRequest(page + 1, pageSize, parentName, makeName, searchTerm));
  }, [page, pageSize, searchTerm, dispatch, makeName, parentName, location.pathname]);


  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    console.log("FILLLLL", file);
    if (file && file.type === "text/csv") {
      setLoading(true);
      try {
        await dispatch(addBulkMakeModel(parentName, makeName, { file }, pageSize, page + 1, searchTerm));
      } catch (err) {
        console.error(err);
        alert("Failed to upload CSV");
      } finally {
        setLoading(false);
      }
    } else {
      alert("Please select a valid CSV file.");
    }
  };



  const syncButtonClickHandle = async (event) => {
    setSyncLoading(true);
    try {
      await dispatch(syncVehiclesData(parentName, makeName, pageSize, page + 1, searchTerm));
    } catch (err) {
      console.error(err);
      alert("Failed to sync make model variant from vehicles");
    } finally {
      setSyncLoading(false);
    }


  };


  return (

    <Paper sx={{ height: "95%", width: '100%' }}>
      <div style={{
        padding: "10px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}>

        <div style={{ display: "flex", flexDirection: "column", gap: "10px", width: "50%" }}>

          <div
            style={{
              fontSize: "15px",
              fontWeight: "600",
              color: "#0d6efd",
              marginBottom: "10px",
              letterSpacing: "0.5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between"
            }}
          >
            <div>

              {/* ✅ Back Button */}
              {makeListing.makeDetail !== null && (
                <button
                  onClick={() => window.history.back()}
                  style={{
                    border: "none",
                    background: "#0d6efd",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "5px",
                    fontSize: "12px",
                    cursor: "pointer",
                    marginRight: "10px",
                  }}
                >
                  ← Back
                </button>
              )}


              {
                makeListing.makeDetail === null ? (
                  <span> MAKE LIST</span>
                ) : makeListing.makeDetail?.type?.toUpperCase() === "MAKE" ? (
                  <span>
                    MODEL LIST OF <strong>{makeListing.makeDetail?.name}</strong> MAKE
                  </span>
                ) : makeListing.makeDetail?.type?.toUpperCase() === "MODEL" ? (
                  <span>
                    VARIANT LIST OF <strong>{makeListing.makeDetail?.name}</strong> MODEL OF{" "}
                    <strong>{makeListing.makeDetail?.parent_name}</strong> MAKE
                  </span>
                ) : null
              }
            </div>

          </div>




          <input
            type="text"
            placeholder="Search by Name"
            value={searchTerm}
            onChange={(e) => {
              setPage(0);
              setSearchTerm(e.target.value);
            }}
            style={{
              padding: "6px 10px",
              fontSize: "14px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              width: "100%"
            }}
          />

        </div>




        <div style={{ display: "flex", gap: "10px" }}>
          <>
            <input
              type="file"
              accept=".csv"
              id="csvUpload2"
              onChange={handleFileChange}
              style={{ display: "none" }}
              disabled={loading}
            />
            <button
              onClick={() => document.getElementById("csvUpload2").click()}
              style={{
                backgroundColor: "black",
                color: "white",
                height: "30px",
                padding: "4px 10px",
                fontSize: "14px",
                border: "none",
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                cursor: loading ? "not-allowed" : "pointer",
                opacity: loading ? 0.7 : 1,
              }}
              disabled={loading}
            >
              {loading ? (
                // simple spinner
                <div
                  style={{
                    border: "2px solid rgba(255,255,255,0.3)",
                    borderTop: "2px solid white",
                    borderRadius: "50%",
                    width: 16,
                    height: 16,
                    animation: "spin 0.6s linear infinite",
                  }}
                />
              ) : (
                "IMPORT CSV"
              )}
            </button>

            {/* spinner keyframes */}
            <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
          </>

          <button
            onClick={() => {
              syncButtonClickHandle();
            }}
            style={{
              backgroundColor: "black",
              color: "white",
              height: "30px",
              padding: "4px 10px",
              fontSize: "14px",
              border: "none",
              borderRadius: "4px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              cursor: syncLoading ? "not-allowed" : "pointer",
              opacity: syncLoading ? 0.7 : 1,
            }}
            disabled={syncLoading}

          >
            {syncLoading ? (
              // simple spinner
              <div
                style={{
                  border: "2px solid rgba(255,255,255,0.3)",
                  borderTop: "2px solid white",
                  borderRadius: "50%",
                  width: 16,
                  height: 16,
                  animation: "spin 0.6s linear infinite",
                }}
              />
            ) : (
              "SYNC"
            )}
          </button>



          <AddMake
            parent_name={parentName}
            make_name={makeName}
            buttonLabel={makeListing.makeDetail == null ? "ADD MAKE" : makeListing.makeDetail?.type?.toUpperCase() === "MAKE" ? "ADD MODEL" : "ADD VARIANT"}
            categories={categories}
            data={makeListing.makeDetail}
            onSave={refreshMakeList}

          />        </div>
      </div>







      <DataGrid
        rows={makeListing.makeListing || []}
        columns={makeListingHeading || []}
        rowCount={makeListing.totalMakes || 0}
        paginationModel={{ page, pageSize }}
        paginationMode="server"
        onPaginationModelChange={({ page, pageSize }) => {
          console.log("pagination----", page, pageSize);
          setPage(page);
          setPageSize(pageSize);
        }}
        pageSizeOptions={[10, 25, 50]}
        rowHeight={"auto"}
        loading={makeListing.loading}
        checkboxSelection={false}
        sx={{ border: 0 }}


      />
    </Paper>
  );
}

//Getting the state from the store
const mapStateToProps = (state) => {
  return {
    makeListing: state.makeReducer, // Add optional chaining
  };
};
//passing the userData in fetchUsers function and also dispatch method
const mapDispatchToProps = (dispatch) => {
  return {
    makeLisitingRequest: () => dispatch({ "type": "GET_MAKE_REQUEST" }), // Corrected function name
  };
};

//Connecting the component to our store
export default connect(mapStateToProps, mapDispatchToProps)(MakeListing);
